var map = {
	"./Avatar.vue": "PRkp",
	"./AvatarCard.vue": "CaOZ",
	"./Body.vue": "Petq",
	"./Btn.vue": "0uDb",
	"./Btn1.vue": "lhfL",
	"./Bubble1.vue": "9pDL",
	"./Bubble2.vue": "PVhF",
	"./Divider.vue": "T4Lp",
	"./Heading.vue": "QxlG",
	"./Heading1.vue": "VbLO",
	"./Icon.vue": "Q7uy",
	"./InfoCard.vue": "+ar0",
	"./SectionHeading.vue": "AdCB",
	"./Subheading.vue": "L9LL",
	"./Subtitle.vue": "7Wu+",
	"./Text.vue": "+5E6",
	"./Title.vue": "KKgh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mPGd";


//////////////////
// WEBPACK FOOTER
// ./src/components/base \.vue$
// module id = mPGd
// module chunks = 1